/* eslint-disable @typescript-eslint/no-explicit-any */
import { APP_LANG } from "@/constants/constants";
import { NetActivity, NetFront } from "@/constants/netEvent.ts";
import { reqGet } from "@/service/clientRequest";
import { reqSvrGet, reqSvrPost } from "@/service/serverRequest.ts";
import {
  GetActivityConfigRsp,
  GetConfigVersionRsp,
  GetGameListRsp,
  GetPageRsp,
  GetSysConfigRsp,
} from "@/types/swagger/front.ts";
import { NullReq } from "@/types/swagger/userwealth.ts";
import { GetActivityStatusRspMap } from "@/types/swaggerex/activity";
import { query } from "@solidjs/router";

// 统一的服务端请求公共参数配置
const getCommonServerParams = () => ({
  apiv: import.meta.env.VITE_API_VERSION ?? 1,
  proj: import.meta.env.VITE_API_PROJECT ?? "afuns",
});

// 合并公共参数的辅助函数
const mergeWithCommonParams = (params: Record<string, unknown> = {}) => ({
  ...params,
  ...getCommonServerParams(),
});

export const getGetConfigVersion = async () => {
  "use server";
  const configVersion = await reqSvrGet<NullReq, GetConfigVersionRsp>(
    mergeWithCommonParams(),
    NetFront.mod,
    NetFront.GetConfigVersion,
  );
  return configVersion;
};

export const postGetPage = async () => {
  "use server";
  const startTime = new Date().getTime();
  const pageConfig = await reqSvrPost<NullReq, GetPageRsp>(
    mergeWithCommonParams({
      keys: ["home", "casino"],
    }),
    NetFront.mod,
    NetFront.GetPage,
  );
  const endTime = new Date().getTime();

  console.log("⏰ postGetPage 请求耗时：", endTime - startTime + "ms");
  // console.log(
  //   "获取页面配置 [postGetPage]-------> pageConfig key: 'home'",
  //   pageConfig.list[0].components,
  // );
  // console.log(
  //   "获取页面配置 [postGetPage]-------> pageConfig key: 'casino'",
  //   pageConfig.list[1].components,
  // );

  return pageConfig;
};

export const initConfig = async () => {
  "use server";
  const [configVersion, pageConfig] = await Promise.all([
    getGetConfigVersion(),
    postGetPage(),
  ]);
  return {
    configVersion,
    pageConfig,
  };
};

export const GetActivityStatus = async () => {
  "use server";
  const activityStatus = await reqSvrGet(
    {},
    NetActivity.mod,
    NetActivity.GetActivityStatus,
  );
  return activityStatus;
};

export const getActivityAllConfig = async () => {
  // 先获取活动状态
  const activityStatus = (await GetActivityStatus()) as GetActivityStatusRspMap;

  // 从活动状态中提取活动类型ID，转换为字符串
  const atypes = Object.keys(activityStatus?.activity_status || {}).join(",");

  // 使用提取的活动类型ID请求活动配置
  const activityCfg = await svrGetActivityCfg(atypes);

  return {
    activityStatus,
    activityCfg,
  };
};

interface componentListParamsType {
  page?: number;
  page_size?: number;
  key: string;
}

export const svrGetComponentList = query(async (gkeys: string) => {
  "use server";

  const componentList = await reqSvrGet(
    mergeWithCommonParams({
      gkeys: gkeys,
      v: "nodejs-" + new Date().toISOString(),
    }),
    NetFront.mod,
    NetFront.GetComponentList,
  );
  return componentList;
}, "NAGetComponentList");

export const svrGetComponent = query(
  async (queryParams: componentListParamsType) => {
    "use server";

    const componentList = await reqSvrGet(
      mergeWithCommonParams({
        key: queryParams.key,
        page: queryParams.page,
        page_size: queryParams.page_size,
        v: "nodejs-" + new Date().toISOString(),
      }),
      NetFront.mod,
      NetFront.GetComponent,
    );
    return componentList;
  },
  "NAGetComponent",
);

export const svrGetSysConfig = query(async () => {
  "use server";
  const sysConfig = await reqSvrGet<NullReq, GetSysConfigRsp>(
    mergeWithCommonParams(),
    NetFront.mod,
    NetFront.GetSysConfig,
  );
  return sysConfig as GetSysConfigRsp;
}, "NAGetSysConfig");
export const svrGetFrontCfgV2 = query(async () => {
  "use server";
  const frontCfg = await reqSvrGet(
    mergeWithCommonParams({
      lang: APP_LANG,
      v: "nodejs-" + new Date().toISOString(),
      tags: ["h5"],
    }),
    NetFront.mod,
    NetFront.GetFrontCfgV2,
  );
  console.log("[svrGetFrontCfgV2] frontCfg ", frontCfg);

  const seoCfg = frontCfg?.list?.find((el: any) => el.key === "SeoCfg");
  (globalThis as Record<string, unknown>).__SEO_CONFIG__ = seoCfg;

  return frontCfg;
}, "NAGetFrontCfgV2");

export const svrGetActivityCfg = query(async (atypes: string) => {
  "use server";

  const activityCfg = await reqSvrGet<
    Record<string, unknown>,
    GetActivityConfigRsp
  >(
    mergeWithCommonParams({
      channel: "-1",
      general: "-1",
      skip_rules: "1",
      labels: "",
      atypes: atypes,
    }),
    NetFront.mod,
    NetFront.GetActivityConfig,
  );

  return activityCfg;
}, "NAGetActivityConfig");
